// Enriches the Spec 2a manage page (#wishlist-page) with live Storefront data, and wires
// tab-switch / remove / move-to-cart. No-ops on every other page.
export function initWishlistManage(page) {
  if (!page || page.dataset.wishlistManageInitialized) return;
  page.dataset.wishlistManageInitialized = "true";
  var CFG = window.WISHLIST_CONFIG || {};
  var H = window.WishlistHelpers;
  var COPY = {
    wishlistedComic: "Wishlisted comic", comicIssue: "Comic issue #{{ issue }}",
    productDetailsUnavailable: "Product details unavailable", productUnavailable: "Product unavailable",
    emptyState: "This list is empty.", addingToCart: "Adding…", addedToCart: "Added!",
    cartError: "Couldn't add", createListPrompt: "Name your new list", renameListPrompt: "Rename list",
    deleteListTitle: "Delete list", deleteOneMessage: 'Delete "{{ name }}" and its 1 item? This can\'t be undone.',
    deleteManyMessage: 'Delete "{{ name }}" and its {{ count }} items? This can\'t be undone.',
    deleteConfirmAction: "Delete list", acceptedConversion: "Accepted", declinedConversion: "Declined",
    pageSummary: "{{ start }}\u2013{{ end }} of {{ total }} \u00b7 Page {{ page }} of {{ pages }}",
    saving: "Saving…", saved: "Saved.", saveError: "Couldn't save that change. Try again.",
    removing: "Removing…", removed: "Item removed.", removeError: "Couldn't remove this item. Try again.",
    moving: "Moving…", moved: "Item moved.", moveError: "Couldn't move this item. Try again.",
    creating: "Creating…", created: "List created.", createError: "Couldn't create that list. Try again.",
    renaming: "Renaming…", renamed: "List renamed.", renameError: "Couldn't rename that list. Try again.",
    deleting: "Deleting…", deleted: "List deleted.", deleteError: "Couldn't delete that list. Try again.",
    trackingOne: "{{ count }} alert", trackingMany: "{{ count }} alerts", statusOn: "On", statusOff: "Off"
  };
  try { COPY = Object.assign(COPY, JSON.parse(page.getAttribute("data-wl-copy") || "{}")); } catch (_) { /* defaults */ }

  function copy(template, values) {
    values = values || {};
    return String(template).replace(/\{\{\s*([a-zA-Z][a-zA-Z0-9_]*)\s*\}\}/g, function (token, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : token;
    });
  }

  var pending = {};
  function statusFor(control) {
    var intro = control && control.closest ? control.closest(".wl-intro-card") : null;
    var item = control && control.closest ? control.closest(".wl-row") : null;
    var settings = control && control.closest ? control.closest(".wl-panel") : null;
    return (intro && intro.querySelector(".wl-intro-status")) ||
      (item && item.querySelector(".wl-row-status")) ||
      (settings && settings.querySelector(".wl-settings-status")) || page.querySelector(".wl-action-status");
  }
  function announce(control, message, isError) {
    var output = statusFor(control);
    if (!output) return;
    output.hidden = false;
    output.textContent = message;
    output.setAttribute("role", isError ? "alert" : "status");
  }
  function claimPending(key) {
    if (pending[key]) return false;
    pending[key] = "claimed";
    return true;
  }
  function releaseClaim(key) { delete pending[key]; }
  function beginPending(key, controls, labelControl, busyText, claimed) {
    if (claimed) {
      if (pending[key] !== "claimed") return null;
    } else if (pending[key]) return null;
    pending[key] = true;
    controls = (controls || []).filter(Boolean);
    var snapshots = controls.map(function (control) {
      return { control: control, disabled: control.disabled, ariaBusy: control.getAttribute ? control.getAttribute("aria-busy") : null };
    });
    var label = labelControl ? labelControl.textContent : null;
    controls.forEach(function (control) {
      control.disabled = true;
      if (control.setAttribute) control.setAttribute("aria-busy", "true");
    });
    if (labelControl && busyText) labelControl.textContent = busyText;
    return function () {
      snapshots.forEach(function (snapshot) {
        snapshot.control.disabled = snapshot.disabled;
        if (!snapshot.control.setAttribute) return;
        if (snapshot.ariaBusy == null && snapshot.control.removeAttribute) snapshot.control.removeAttribute("aria-busy");
        else snapshot.control.setAttribute("aria-busy", snapshot.ariaBusy);
      });
      if (labelControl) labelControl.textContent = label;
      delete pending[key];
    };
  }
  function committed(control, kind) {
    var value = control && control.getAttribute ? control.getAttribute("data-wl-committed") : null;
    return kind === "checked" ? value === "true" : (value == null ? "" : value);
  }
  function commit(control, value) {
    if (control && control.setAttribute) control.setAttribute("data-wl-committed", String(value));
  }
  function updateAlertSummary(previous, next) {
    if (previous === next) return;
    var delta = next ? 1 : -1;
    Array.prototype.slice.call(page.querySelectorAll("[data-wl-alert-count]")).forEach(function (output) {
      var count = Math.max(0, (parseInt(output.getAttribute("data-wl-alert-count") || "0", 10) || 0) + delta);
      output.setAttribute("data-wl-alert-count", String(count));
      output.textContent = copy(count === 1 ? COPY.trackingOne : COPY.trackingMany, { count: count });
    });
  }
  function updateChannelSummary(channel, enabled) {
    var output = page.querySelector('[data-wl-channel-state="' + channel + '"]');
    if (output) output.textContent = enabled ? COPY.statusOn : COPY.statusOff;
  }
  function succeeded(result) { return !!(result && result.ok); }

  function boundedFetch(url, options) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);
    if (timeout.unref) timeout.unref();
    options.signal = controller.signal;
    return fetch(url, options).finally(function () { clearTimeout(timeout); });
  }

  function sf(query, variables) {
    return boundedFetch("https://" + CFG.storefrontDomain + "/api/" + CFG.storefrontApiVersion + "/graphql.json", {
      method: "POST",
      headers: { "content-type": "application/json", "X-Shopify-Storefront-Access-Token": CFG.storefrontToken },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  // The server emits one stable date-ordered page. baseOrder lets a complete
  // one-page list return to that order after a client-side price/title sort.
  var baseOrder = [], state = { sort: "date", order: [] };
  var itemTotal = parseInt(page.getAttribute("data-wl-item-total") || "0", 10) || 0;
  var sortStatus = page.querySelector(".wl-sort-status");
  var viewSel = page.querySelector(".wl-view");

  var VIEW_KEY = "captcan:wl:view";
  // localStorage itself throws in private-mode Safari, so even the read is guarded
  function readPref(key) { try { return localStorage.getItem(key); } catch (_) { return null; } }
  function writePref(key, value) { try { localStorage.setItem(key, value); } catch (_) { /* ignore */ } }
  // assigning an unmatched value leaves a <select> on "", which is how a stale
  // preference gets rejected without enumerating the options
  function restoreSelect(select, key) {
    var stored = readPref(key);
    if (!select || !stored) return;
    var current = select.value;
    select.value = stored;
    if (!select.value) select.value = current;
  }

  function applyOrder() {
    for (var i = 0; i < state.order.length; i++) {
      var row = state.order[i];
      row.style.order = String(i);
      row.hidden = !!row.wlUnavailableHidden;
    }
    enrichRows(state.order);
  }

  // Sort always reads baseOrder, so switching back to "date" restores the render order.
  function reorder(mode) {
    var items = baseOrder.map(function (row, i) {
      var priceTxt = (row.querySelector('[data-enrich="price"]') || {}).textContent || "";
      var m = priceTxt.replace(/[^0-9.]/g, "");
      var titleTxt = (row.querySelector('[data-enrich="title"]') || {}).textContent || "";
      return { pos: i, price: m ? parseFloat(m) : null, title: titleTxt };
    });
    var ordered = H.sortItems(items, mode);
    state.order = new Array(baseOrder.length);
    ordered.forEach(function (o) { state.order[o.order] = baseOrder[o.pos]; });
    applyOrder();
  }

  // price/title rank on enriched text, so the whole list must be enriched before sorting —
  // otherwise page 1 of 9 would sort against blanks and read as a bug.
  function applySort(mode) {
    state.sort = mode;
    if (sortStatus) sortStatus.hidden = true;
    if (!H || !H.sortItems) {
      state.order = baseOrder.slice();
      applyOrder();
      return;
    }
    if (mode === "date") return reorder(mode);
    if (itemTotal > baseOrder.length) {
      if (sortStatus) sortStatus.hidden = false;
      return;
    }
    page.classList.add("is-sorting");
    var done = function () { page.classList.remove("is-sorting"); reorder(mode); };
    enrichRows(baseOrder).then(done, done);
  }

  // --- Storefront enrich: one nodes() request per CHUNK gids, MAX_CHUNKS in flight ---
  var CHUNK = 25, MAX_CHUNKS = 3;
  var PRODUCT_QUERY = "query WishlistProducts($ids:[ID!]!) { nodes(ids:$ids){ ... on Product { id title availableForSale onlineStoreUrl featuredImage{url} " +
    "releaseYear: metafield(namespace:\"product\",key:\"release_year\"){ value } " +
    "priceRange{minVariantPrice{amount currencyCode}} variants(first:1){nodes{id availableForSale}} } } }";
  var productCache = {}, waitingByGid = {}, queuedGids = [], unavailableRows = [], inFlight = 0;
  var drainPromise = null, drainResolve = null;

  function enrichRows(rows) {
    if (!rows || !rows.length) return drainPromise || Promise.resolve();
    var helpersReady = H && H.uniqueGids && H.formatMoney && H.sortItems;
    var isSentinel = H && H.isIssueSentinel ? H.isIssueSentinel : function () { return false; };
    var normalizeProductGid = H && H.normalizeProductGid ? H.normalizeProductGid : function (raw) {
      var value = String(raw).trim();
      if (/^\d+$/.test(value)) return "gid://shopify/Product/" + value;
      return /^gid:\/\/shopify\/Product\/\d+$/.test(value) ? value : null;
    };
    var sentinelRows = [];
    rows.forEach(function (row) {
      if (row.wlEnrichStarted) return;
      row.wlEnrichStarted = true;
      var storedGid = row.getAttribute("data-product-gid");
      if (!storedGid) return;
      if (isSentinel(storedGid)) { sentinelRows.push(row); return; }
      var cart = row.querySelector('[data-enrich="addtocart"]');
      if (cart) cart.disabled = true;
      if (!helpersReady) { finish(row, escapeHtml(COPY.productDetailsUnavailable), "is-enrich-error"); return; }
      var gid = normalizeProductGid(storedGid);
      if (!gid) {
        if (row.closest(".wl-list") && row.getAttribute("data-item-id")) unavailableRows.push(row);
        else finish(row, escapeHtml(COPY.productUnavailable), "is-unavailable");
        return;
      }
      if (productCache[gid]) { applyProduct(row, gid, productCache[gid]); return; }
      if (waitingByGid[gid]) { waitingByGid[gid].push(row); return; }
      waitingByGid[gid] = [row];
      queuedGids.push(gid);
    });
    resolveSentinels(sentinelRows);
    return pump();
  }

  function pump() {
    if (!queuedGids.length && !inFlight) {
      if (unavailableRows.length) return resolveUnavailableRows(unavailableRows.splice(0));
      return Promise.resolve();
    }
    if (!drainPromise) drainPromise = new Promise(function (r) { drainResolve = r; });
    startChunks();
    return drainPromise;
  }

  function startChunks() {
    while (inFlight < MAX_CHUNKS && queuedGids.length) {
      inFlight += 1;
      requestChunk(queuedGids.splice(0, CHUNK)).finally(function () {
        inFlight -= 1;
        if (queuedGids.length) startChunks();
        else if (!inFlight && drainResolve) {
          resolveUnavailableRows(unavailableRows.splice(0)).finally(function () {
            var done = drainResolve;
            drainPromise = null;
            drainResolve = null;
            done();
          });
        }
      });
    }
  }

  function requestChunk(ids) {
    return sf(PRODUCT_QUERY, { ids: ids }).then(function (res) {
      // distinguish a gone product from a transient Storefront failure
      var responded = !!(res && res.data && !res.errors);
      var nodes = (res && res.data && res.data.nodes) || [];
      ids.forEach(function (gid, i) {
        var entry = { node: nodes[i] || null, responded: responded };
        productCache[gid] = entry;
        (waitingByGid[gid] || []).forEach(function (row) { applyProduct(row, gid, entry); });
        delete waitingByGid[gid];
      });
    });
  }

  function applyProduct(row, gid, entry) {
    var n = entry.node;
    if (!n) {
      // Storefront null is not proof that the product was deleted: unpublished,
      // draft, and archived products are also invisible to this token. Real list
      // rows go through the authenticated Admin/issue fallback before we decide.
      if (entry.responded && row.closest(".wl-list") && row.getAttribute("data-item-id")) unavailableRows.push(row);
      else if (entry.responded) finish(row, escapeHtml(COPY.productUnavailable), "is-unavailable");
      else finish(row, escapeHtml(COPY.productDetailsUnavailable), "is-enrich-error");
      return;
    }
    var v = n.variants && n.variants.nodes && n.variants.nodes[0];
    var imgUrl = n.featuredImage && n.featuredImage.url ? n.featuredImage.url : "";
    if (imgUrl) imgUrl += (imgUrl.indexOf("?") === -1 ? "?" : "&") + "width=128"; // shrink full-res cover into the 64px box
    fill(row, "image", imgUrl ? '<img src="' + escapeHtml(imgUrl) + '" alt="" loading="lazy" width="64">' : "");
    if (imgUrl) row.classList.remove("has-no-cover");
    fill(row, "price", H.formatMoney(n.priceRange && n.priceRange.minVariantPrice));
    var cart = row.querySelector('[data-enrich="addtocart"]');
    var canShop = n.availableForSale === true && !!n.onlineStoreUrl;
    if (!canShop && row.closest(".wl-list")) {
      row.wlUnavailableHidden = true;
      row.hidden = true;
    }
    if (cart && canShop && v && v.availableForSale) {
      cart.hidden = false;
      cart.disabled = false;
      cart.setAttribute("data-variant-id", v.id.split("/").pop());
    }
    var yr = n.releaseYear && n.releaseYear.value ? escapeHtml(n.releaseYear.value) : "";
    var title = escapeHtml(n.title);
    if (canShop) title = '<a href="' + escapeHtml(n.onlineStoreUrl) + '">' + title + '</a>';
    finish(row, title +
      (yr ? ' <span class="wl-year">(' + yr + ")</span>" : ""));
  }

  function resolveUnavailableRows(rows) {
    if (!rows.length) return Promise.resolve();
    var itemIds = rows.map(function (row) { return row.getAttribute("data-item-id"); }).filter(Boolean);
    return api("/fallbacks", { method: "POST", body: { itemIds: itemIds } }).then(function (result) {
      if (!succeeded(result)) {
        rows.forEach(function (row) {
          finish(row, escapeHtml(COPY.productDetailsUnavailable), "is-enrich-error");
        });
        return;
      }
      var fallbacks = result.fallbacks || {};
      rows.forEach(function (row) {
        var fallback = fallbacks[row.getAttribute("data-item-id")];
        // Recovered labels do not make a Storefront-invisible product shoppable.
        // Keep the saved entry for restock alerts, but hide its product card.
        row.wlUnavailableHidden = true;
        row.hidden = true;
        if (!fallback || !fallback.title) {
          finish(row, "", "is-unavailable");
          return;
        }
        var imgUrl = fallback.imageUrl || "";
        if (imgUrl) {
          imgUrl += (imgUrl.indexOf("?") === -1 ? "?" : "&") + "width=128";
          fill(row, "image", '<img src="' + escapeHtml(imgUrl) + '" alt="" loading="lazy" width="64">');
          row.classList.remove("has-no-cover");
        }
        finish(row, escapeHtml(fallback.title), "is-product-fallback");
      });
    });
  }

  // sentinel rows carry a non-Shopify gid that would error nodes() — resolve them by issue id
  function resolveSentinels(rows) {
    if (!rows.length) return;
    var issueIds = [];
    rows.forEach(function (row) {
      var issueId = row.getAttribute("data-issue-id");
      // issue-less sentinel can't be resolved — finish now
      if (issueId) issueIds.push(issueId);
      else finish(row, escapeHtml(COPY.wishlistedComic), "is-unavailable");
    });
    if (!issueIds.length) return;
    boundedFetch(CFG.proxyBase + "/search/issue-titles", {
      method: "POST", credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ issueIds: issueIds })
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (res) {
        var titles = (res && res.titles) || {}; // on failure: fall back to "Comic issue #X", never stay stuck
        rows.forEach(function (row) {
          var issueId = row.getAttribute("data-issue-id");
          if (!issueId) return;
          if (titles[issueId]) finish(row, escapeHtml(titles[issueId]));
          else finish(row, escapeHtml(copy(COPY.comicIssue, { issue: issueId })), "is-unavailable");
        });
      });
  }

  // adjust the active tab's trailing "(N)" count; cosmetic — the items stay in the DB (product may return)
  function bumpActiveCount(delta) {
    var tab = page.querySelector(".wl-tab.is-active");
    if (!tab) return;
    tab.textContent = tab.textContent.replace(/\((\d+)\)\s*$/, function (_, n) {
      return "(" + Math.max(0, parseInt(n, 10) + delta) + ")";
    });
  }
  // user removed/moved a row: drop it and keep the tab "(N)" + empty-state honest.
  // refreshBadge only on a real delete (move keeps the item in the wishlist, so the
  // header total is unchanged); refresh() re-syncs the global badge from the server.
  function dropRow(row, refreshBadge) {
    row.remove();
    for (var i = 0; i < baseOrder.length; i++) if (baseOrder[i] === row) { baseOrder.splice(i, 1); break; }
    for (var j = 0; j < state.order.length; j++) if (state.order[j] === row) { state.order.splice(j, 1); break; }
    bumpActiveCount(-1);
    var list = page.querySelector(".wl-list");
    if (list && !list.querySelector(".wl-row")) list.innerHTML = '<li class="account-info-item wl-empty-card">' + escapeHtml(COPY.emptyState) + '</li>';
    if (refreshBadge && window.WISHLIST && window.WISHLIST.refresh) window.WISHLIST.refresh(document);
    applyOrder();
  }
  function refreshCurrentPage() {
    if (window.MyCaptCanNavigation && typeof window.MyCaptCanNavigation.refresh === "function") {
      return window.MyCaptCanNavigation.refresh();
    }
    location.reload();
  }

  var introDialog = page.querySelector(".wl-intro-modal");
  var introReturnFocus = introDialog && document.activeElement;
  function closeIntroDialog(modal) {
    modal.remove();
    introDialog = null;
    if (introReturnFocus && typeof introReturnFocus.focus === "function") introReturnFocus.focus();
  }
  if (introDialog) {
    try {
      // The native top layer escapes animated/transformed theme containers.
      // Keep the server's display:none until the dialog has opened successfully.
      introDialog.showModal();
      introDialog.style.removeProperty("display");
      introDialog.addEventListener("cancel", function (event) {
        event.preventDefault();
        if (introDialog) closeIntroDialog(introDialog);
      });
      introDialog.addEventListener("close", function () {
        if (introDialog) closeIntroDialog(introDialog);
      });
    } catch (_) {
      closeIntroDialog(introDialog);
    }
  }
  if (introDialog && introDialog.querySelectorAll) {
    var introButtons = Array.prototype.slice.call(introDialog.querySelectorAll("button"));
    if (introButtons[0] && typeof introButtons[0].focus === "function") introButtons[0].focus();
    page.addEventListener("keydown", function (event) {
      if (!introDialog || event.key !== "Tab") return;
      var buttons = Array.prototype.slice.call(introDialog.querySelectorAll("button"))
        .filter(function (button) { return !button.disabled; });
      if (!buttons.length) return;
      var current = buttons.indexOf(document.activeElement);
      if (event.shiftKey && current <= 0) {
        event.preventDefault();
        buttons[buttons.length - 1].focus();
      } else if (!event.shiftKey && (current === -1 || current === buttons.length - 1)) {
        event.preventDefault();
        buttons[0].focus();
      }
    });
  }
  function fill(row, slot, html) {
    var el = row.querySelector('[data-enrich="' + slot + '"]');
    if (el) el.innerHTML = html;
  }
  // fill the title slot + drop the skeleton; called once a row's data (or its terminal fallback) is known
  function finish(row, titleHtml, stateClass) {
    fill(row, "title", titleHtml);
    row.classList.remove("is-loading");
    if (stateClass) row.classList.add(stateClass);
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  page.addEventListener("click", function (e) {
    if (e.target.closest(".wl-intro-close")) {
      if (introDialog) closeIntroDialog(introDialog);
      return;
    }
    var keep = e.target.closest(".wl-intro-keep");
    var dismiss = e.target.closest(".wl-intro-dismiss");
    if (keep || dismiss) {
      var introModal = page.querySelector(".wl-intro-modal");
      var introKey = "prefs:intro";
      var introControls = introModal && introModal.querySelectorAll
        ? Array.prototype.slice.call(introModal.querySelectorAll("button")).filter(function (button) {
          return !button.classList.contains("wl-intro-close");
        })
        : [keep, dismiss].filter(Boolean);
      var finishIntro = beginPending(introKey, introControls, keep || dismiss, COPY.saving);
      if (!finishIntro) return;
      var choice = keep ? "keep" : "wishlist-only";
      announce(keep || dismiss, COPY.saving, false);
      Promise.all([
        api("/prefs", { method: "POST", body: { intent: "intro", choice: choice } }),
        // also persist the durable conversion choice (ACCEPTED/DECLINED) the settings panel reads
        api("/prefs", { method: "POST", body: { intent: "conversion", choice: keep ? "ACCEPTED" : "DECLINED" } }),
      ]).then(function (results) {
        finishIntro();
        if (!results.every(succeeded)) {
          announce(keep || dismiss, COPY.saveError, true);
          return;
        }
        announce(null, COPY.saved, false);
        if (introModal) closeIntroDialog(introModal);
        // reload only AFTER both POSTs settle — a sync reload aborts the in-flight fetch and loses the opt-out
        if (dismiss) location.reload();
      });
      return;
    }
    var rm = e.target.closest(".wl-remove");
    if (rm) {
      var row = rm.closest("[data-item-id]");
      if (!row) return;
      var removeKey = "item:" + row.getAttribute("data-item-id") + ":remove";
      var finishRemove = beginPending(removeKey, [rm], rm, COPY.removing);
      if (!finishRemove) return;
      announce(rm, COPY.removing, false);
      api("/items", { method: "DELETE", body: { id: row.getAttribute("data-item-id") } })
        .then(function (result) {
          if (!succeeded(result)) {
            finishRemove();
            announce(rm, COPY.removeError, true);
            return;
          }
          announce(rm, COPY.removed, false);
          refreshCurrentPage();
        });
      return;
    }
    var cart = e.target.closest('[data-enrich="addtocart"]');
    if (cart && cart.getAttribute("data-variant-id")) {
      var orig = cart.textContent; cart.disabled = true; cart.textContent = COPY.addingToCart;
      Promise.resolve().then(function () {
        return window.WISHLIST.addToCart(cart.getAttribute("data-variant-id"));
      }).catch(function () { return false; }).then(function (ok) {
        cart.textContent = ok ? COPY.addedToCart : COPY.cartError;
        if (!ok) cart.disabled = false;
        var reset = setTimeout(function () { cart.textContent = orig; cart.disabled = false; }, 2000);
        if (reset.unref) reset.unref();
      });
    }
  });

  function api(path, opts) {
    opts = opts || {};
    return boundedFetch(CFG.proxyBase + "/wishlist" + path, {
      method: opts.method || "GET", credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function gotoList(id) { location.search = "?list=" + encodeURIComponent(id); }

  // create / rename / delete (delete uses the shared confirm modal)
  page.addEventListener("click", function (e) {
    var create = e.target.closest(".wl-create");
    if (create) {
      var createKey = "list:create";
      if (!claimPending(createKey)) return;
      var name = window.prompt(COPY.createListPrompt);
      if (name && name.trim()) {
        var finishCreate = beginPending(createKey, [create], create, COPY.creating, true);
        if (!finishCreate) return;
        announce(create, COPY.creating, false);
        api("/lists", { method: "POST", body: { name: name.trim() } }).then(function (result) {
          finishCreate();
          if (succeeded(result) && result.list) {
            announce(create, COPY.created, false);
            gotoList(result.list.id);
          } else announce(create, COPY.createError, true);
        });
      } else releaseClaim(createKey);
      return;
    }
    var ren = e.target.closest("[data-wl-rename]");
    if (ren) {
      var renameKey = "list:" + ren.getAttribute("data-list-id") + ":rename";
      if (!claimPending(renameKey)) return;
      var tab = page.querySelector(".wl-tab.is-active");
      var current = tab ? tab.textContent.replace(/\s*\(\d+\)\s*$/, "") : "";
      var next = window.prompt(COPY.renameListPrompt, current);
      if (next && next.trim() && next.trim() !== current) {
        var finishRename = beginPending(renameKey, [ren], ren, COPY.renaming, true);
        if (!finishRename) return;
        announce(ren, COPY.renaming, false);
        api("/lists", { method: "PATCH", body: { id: ren.getAttribute("data-list-id"), name: next.trim() } })
          .then(function (result) {
            finishRename();
            if (succeeded(result)) {
              announce(ren, COPY.renamed, false);
              location.reload();
            } else announce(ren, COPY.renameError, true);
          });
      } else releaseClaim(renameKey);
      return;
    }
    var del = e.target.closest("[data-wl-delete]");
    if (del) {
      var nm = del.getAttribute("data-list-name"), n = parseInt(del.getAttribute("data-list-count") || "0", 10) || 0;
      var deleteKey = "list:" + del.getAttribute("data-list-id") + ":delete";
      if (!claimPending(deleteKey)) return;
      window.WISHLIST.confirm({
        title: COPY.deleteListTitle,
        message: copy(n === 1 ? COPY.deleteOneMessage : COPY.deleteManyMessage, { name: nm, count: n }),
        confirmLabel: COPY.deleteConfirmAction,
      }).then(function (ok) {
        if (!ok) { releaseClaim(deleteKey); return; }
        var finishDelete = beginPending(deleteKey, [del], del, COPY.deleting, true);
        if (!finishDelete) return;
        announce(del, COPY.deleting, false);
        api("/lists", { method: "DELETE", body: { id: del.getAttribute("data-list-id") } })
          .then(function (result) {
            finishDelete();
            if (succeeded(result)) {
              announce(del, COPY.deleted, false);
              gotoList("");
            } else announce(del, COPY.deleteError, true);
          });
      });
      return;
    }
  });

  // move an item to another list; alert toggle + grade select
  page.addEventListener("change", function (e) {
    var dt = e.target.closest(".wl-default-tier");
    if (dt) {
      var priorTier = committed(dt, "value");
      var nextTier = dt.value;
      var finishTier = beginPending("prefs:default-tier", [dt], null, null);
      if (!finishTier) { dt.value = priorTier; return; }
      announce(dt, COPY.saving, false);
      api("/prefs", { method: "POST", body: { intent: "default-tier", tier: nextTier } }).then(function (result) {
        finishTier();
        if (succeeded(result)) {
          commit(dt, nextTier);
          announce(dt, COPY.saved, false);
        } else {
          dt.value = priorTier;
          announce(dt, COPY.saveError, true);
        }
      });
      return;
    }
    // channel toggles: the schema needs both email + sms, so post the current state of both
    var ch = e.target.closest(".wl-channel-email, .wl-channel-sms");
    if (ch) {
      var emailBox = page.querySelector(".wl-channel-email");
      var smsBox = page.querySelector(".wl-channel-sms");
      var priorEmail = committed(emailBox, "checked");
      var priorSms = committed(smsBox, "checked");
      var nextEmail = !!(emailBox && emailBox.checked);
      var nextSms = !!(smsBox && smsBox.checked && !smsBox.disabled);
      var finishChannels = beginPending("prefs:channels", [emailBox, smsBox], null, null);
      if (!finishChannels) {
        if (emailBox) emailBox.checked = priorEmail;
        if (smsBox) smsBox.checked = priorSms;
        return;
      }
      announce(ch, COPY.saving, false);
      api("/prefs", { method: "POST", body: {
        intent: "channels",
        email: nextEmail,
        sms: nextSms,
      } }).then(function (result) {
        finishChannels();
        if (succeeded(result)) {
          commit(emailBox, nextEmail);
          commit(smsBox, nextSms);
          updateChannelSummary("email", nextEmail);
          updateChannelSummary("sms", nextSms);
          announce(ch, COPY.saved, false);
        } else {
          if (emailBox) emailBox.checked = priorEmail;
          if (smsBox) smsBox.checked = priorSms;
          announce(ch, COPY.saveError, true);
        }
      });
      return;
    }
    var at = e.target.closest(".wl-alert-toggle");
    if (at) {
      var arow = at.closest("[data-item-id]");
      var gsel = arow.querySelector(".wl-grade");
      var previousAlert = committed(at, "checked");
      var nextAlert = at.checked;
      var alertKey = "item:" + arow.getAttribute("data-item-id") + ":alert-settings";
      var finishAlert = beginPending(alertKey, [at, gsel], null, null);
      if (!finishAlert) { at.checked = previousAlert; return; }
      if (gsel) gsel.classList.toggle("is-hidden", !at.checked);
      arow.classList.toggle("is-alert-on", at.checked);
      announce(at, COPY.saving, false);
      api("/items", { method: "PATCH", body: { id: arow.getAttribute("data-item-id"), alert: nextAlert } }).then(function (result) {
        finishAlert();
        if (succeeded(result)) {
          commit(at, nextAlert);
          updateAlertSummary(previousAlert, nextAlert);
          announce(at, COPY.saved, false);
        } else {
          at.checked = previousAlert;
          if (gsel) gsel.classList.toggle("is-hidden", !previousAlert);
          arow.classList.toggle("is-alert-on", previousAlert);
          announce(at, COPY.saveError, true);
        }
      });
      return;
    }
    var gr = e.target.closest(".wl-grade");
    if (gr) {
      var grow = gr.closest("[data-item-id]");
      var previousGrade = committed(gr, "value");
      var nextGrade = gr.value;
      var gradeKey = "item:" + grow.getAttribute("data-item-id") + ":alert-settings";
      var gradeToggle = grow.querySelector(".wl-alert-toggle");
      var finishGrade = beginPending(gradeKey, [gr, gradeToggle], null, null);
      if (!finishGrade) { gr.value = previousGrade; return; }
      announce(gr, COPY.saving, false);
      api("/items", { method: "PATCH", body: { id: grow.getAttribute("data-item-id"), alertGrade: nextGrade } }).then(function (result) {
        finishGrade();
        if (succeeded(result)) {
          commit(gr, nextGrade);
          announce(gr, COPY.saved, false);
        } else {
          gr.value = previousGrade;
          announce(gr, COPY.saveError, true);
        }
      });
      return;
    }
    var mv = e.target.closest(".wl-move");
    if (mv && mv.value) {
      var row = mv.closest("[data-item-id]");
      var previousList = committed(mv, "value");
      var nextList = mv.value;
      var moveKey = "item:" + row.getAttribute("data-item-id") + ":move";
      var finishMove = beginPending(moveKey, [mv], null, null);
      if (!finishMove) { mv.value = previousList; return; }
      announce(mv, COPY.moving, false);
      api("/items", { method: "PATCH", body: { id: row.getAttribute("data-item-id"), toListId: nextList } })
        .then(function (result) {
          if (succeeded(result)) {
            commit(mv, nextList);
            announce(mv, COPY.moved, false);
            refreshCurrentPage();
          } else {
            finishMove();
            mv.value = previousList;
            announce(mv, COPY.moveError, true);
          }
        });
      return;
    }
    var viewPick = e.target.closest(".wl-view");
    if (viewPick) {
      page.dataset.wlView = viewPick.value;
      writePref(VIEW_KEY, viewPick.value);
      return;
    }
    var sizePick = e.target.closest(".wl-server-pagesize");
    if (sizePick) {
      var params = new URLSearchParams(location.search);
      params.set("page", "1");
      params.set("pageSize", sizePick.value);
      location.search = "?" + params.toString();
      return;
    }
    var sort = e.target.closest(".wl-sort");
    if (sort) applySort(sort.value);
  });

  baseOrder = Array.prototype.slice.call(page.querySelectorAll(".wl-row"));
  state.order = baseOrder.slice();
  restoreSelect(viewSel, VIEW_KEY);
  if (viewSel) page.dataset.wlView = viewSel.value;
  applyOrder();
  // intro-modal preview rows share the enrich contract but sit outside the paged list
  enrichRows(Array.prototype.slice.call(page.querySelectorAll(".wl-intro-row")));
}

if (typeof document !== "undefined") {
  initWishlistManage(document.getElementById("wishlist-page"));
  document.addEventListener("mycaptcan:replace", function () {
    initWishlistManage(document.getElementById("wishlist-page"));
  });
}
